module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-DemiLight-Hestia.1914ca3.eot";